<template>
  <div class="mt-3">
    <b-tab
      v-if="visible"
      :active="active"
      class="custom-tab-item"
      :lazy="lazy"
      :tabindex="tabindex"
      tag="div"
      :title-item-class="navItemClass"
      :title-link-class="navLinkClass"
      @click="$emit('click', $event)"
    >
      <template #title>
        <div class="d-flex text-center justify-content-center">
          <div :class="hasError && 'mr-2'">
            {{ title }}
          </div>
          <div
            v-if="hasError"
            class="d-flex justify-content-center align-items-center title-tab-wrapper"
          >
            <i
              class="fas fa-exclamation-triangle text-danger error-icon"
              :class="active && 'txt-white'"
            />
          </div>
        </div>
      </template>
      <slot />
    </b-tab>
  </div>
</template>

<script>
import { BTab } from 'bootstrap-vue';
export default {
  name: 'QTabItem',
  components: {
    BTab,
  },
  props: {
    lazy: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: () => false,
    },
    navItemClass: {
      type: [Object, String],
      default: () => '',
    },
    navLinkClass: {
      type: [Object, String],
      default: () => '',
    },
    hasError: {
      type: Boolean,
      default: () => false,
    },
    tabindex: {
      type: Number,
      required: true,
    },
    visible: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>
<style scoped>
.error-icon {
  position: absolute;
  margin-left: 5px;
  font-size: 18px;
  color: #ff5b5c !important;
}

.txt-white {
  color: #fff !important;
}

.title-tab-wrapper {
  min-width: 20px !important;
}
</style>
